// Selector de idioma ES|EN. Compartido por la barra del panel y el login,
// para que el tester pueda fijar el idioma antes de entrar. La preferencia
// persiste en localStorage (ver lib/i18n).

import { useI18n, type Lang } from '@/lib/i18n';

export function LangSwitch() {
  const { lang, setLang, t } = useI18n();
  const opt = (l: Lang) => (
    <button
      type="button"
      onClick={() => setLang(l)}
      aria-pressed={lang === l}
      className={`px-1.5 py-0.5 uppercase tracking-wider ${
        lang === l ? 'bg-brand/20 text-brand' : 'text-ink-subtle hover:text-ink'
      }`}
    >
      {l}
    </button>
  );
  return (
    <span
      role="group"
      aria-label={t('shell.langTitle')}
      title={t('shell.langTitle')}
      className="flex items-center divide-x divide-surface-border-strong rounded border border-surface-border-strong text-[11px]"
    >
      {opt('es')}
      {opt('en')}
    </span>
  );
}
